"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var prepareUDO = void 0;

var getTargetAndAncestors = function getTargetAndAncestors(el, nodeArr) {
  nodeArr === undefined ? nodeArr = [el] : nodeArr.push(el);
  return el.nodeName !== "BODY" && el.parentNode !== null ? getTargetAndAncestors(el.parentNode, nodeArr) : nodeArr;
};

function init(tealiumProfile, tealiumEnv, _prepareUDO) {
  var bindLinkEvents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var appTrackedElements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var protocol = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";

  if (typeof tealiumProfile !== "string") {
    throw Error("tealiumProfile string must be provided to utag.init. Got " + (typeof tealiumProfile === "undefined" ? "undefined" : _typeof(tealiumProfile)) + ".");
  }
  if (typeof tealiumEnv !== "string") {
    throw Error("tealiumEnv string must be provided to utag.init. Got " + (typeof tealiumEnv === "undefined" ? "undefined" : _typeof(tealiumEnv)) + ".");
  }
  if (typeof _prepareUDO !== "function") {
    throw Error("_prepareUDO function must be provided to utag.init. Got " + (typeof _prepareUDO === "undefined" ? "undefined" : _typeof(_prepareUDO)) + ".");
  }
  if (protocol && !["https"].includes(protocol)) {
    throw new Error("protocol can only be \"https\". Got " + protocol);
  }

  loadExternalUtag(tealiumProfile, tealiumEnv, protocol);

  prepareUDO = _prepareUDO;

  if (bindLinkEvents) {
    var bindListener = function bindListener(trackedEventType) {
      document.body.addEventListener(trackedEventType, function (e) {
        var matchedElement = getTargetAndAncestors(e.target).find(function isTrackedElement(el) {
          return (document.documentElement.matches || document.documentElement.msMatchesSelector).call(el, trackedElements[trackedEventType].join(","));
        });
        matchedElement && link({
          el: matchedElement,
          trackedEventType: trackedEventType
        });
      });
    };

    var trackedElements = {
      click: ["a", "button:not([data-dpz-no-track])", "input[type=\"submit\"]", "[data-dpz-track-evt]"].concat(_toConsumableArray(appTrackedElements.click || [])),
      change: ["input[type=\"checkbox\"]", "input[type=\"radio\"]", "select"].concat(_toConsumableArray(appTrackedElements.change || []))
    };

    Object.keys(trackedElements).forEach(bindListener);
  }
}

function loadExternalUtag(tealiumProfile, tealiumEnv, protocol) {

  // Create a global promise that the remote tealium js file will resolve as a signal that it has loaded
  // and is ready to receive view and link calls
  window.remoteUtagPromise = new Promise(function (resolve, reject) {
    window.remoteUtagReady = resolve;
  });

  var a = (protocol ? protocol + "://" : "//") + "tags.tiqcdn.com/utag/dominos/" + tealiumProfile + "/" + tealiumEnv + "/utag.js";
  var b = document;
  var c = "script";
  var d = b.createElement(c);

  d.src = a;
  d.type = "text/java" + c;
  d.async = true;

  a = b.getElementsByTagName(c)[0];
  a.parentNode.insertBefore(d, a);
}

function view() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof window.remoteUtagPromise === "undefined" || typeof window.remoteUtagPromise.then !== "function") {
    throw Error("window.remoteUtagPromise must be a Promise.");
  }

  var udo = _extends({
    page_name: options.title || document.title,
    page_url: window.location.href
  }, prepareUDO(options.eventData));

  window.remoteUtagPromise.then(function (value) {
    window.utag.view(udo);
  });
}

function link() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var optionsPropertyBlackList = ["el", "trackedEventType", "eventData"];

  if (typeof window.remoteUtagPromise === "undefined" || typeof window.remoteUtagPromise.then !== "function") {
    throw Error("window.remoteUtagPromise must be a Promise.");
  }

  // this comes from calling link directly
  var filteredOptionsProperties = Object.keys(options).filter(function (property) {
    return !optionsPropertyBlackList.includes(property);
  }).reduce(function (obj, property) {
    obj[property] = options[property];
    return obj;
  }, {});

  // this comes from the global click event on buttons and other tracked elements
  var variablesFromDataDpzTrack = options.el ? prepareLink.getTealiumVariablesFromDataDpzTrack(options.el) : {};

  var udo = _extends({
    page_name: document.title,
    page_url: window.location.href,
    event_name: options.el && prepareLink.getName(options.el),
    event_action: options.el && prepareLink.getAction(options.el, options.trackedEventType) || "click",
    event_category: prepareLink.getCategory(options.el),
    event_label: options.el && prepareLink.getLabel(options.el) || null
  }, prepareUDO(options.eventData), filteredOptionsProperties, variablesFromDataDpzTrack);

  window.remoteUtagPromise.then(function (value) {
    window.utag.link(udo);
  });
}

var prepareLink = {
  getName: function getName(el) {
    return el.getAttribute("data-dpz-track-evt-name") || prepareLink.getNameFromContents(el) || el.getAttribute("value") || el.getAttribute("name");
  },
  getNameFromContents: function getNameFromContents(el) {
    if (el.nodeName === "SELECT" && el.value) {
      // Select the selected option from the select
      return el.getAttribute("name") + " - " + el.value;
    } else if (/\S/.test(el.textContent)) {
      // If the text contains any non-whitespace character, return that text
      return el.textContent.trim();
    } else {
      // else, see if it has a child image, and use its alt attribute
      var childImg = el.querySelector("img");
      return childImg && childImg.getAttribute("alt");
    }
  },
  getNameFromInputLabel: function getNameFromInputLabel() {
    // TODO when we need to handle radios and checkboxes
  },
  getAction: function getAction(el, trackedEventType) {
    return el.getAttribute("data-dpz-track-evt-type") || el.getAttribute("data-dpz-track-event-type") || trackedEventType || "click";
  },
  getCategory: function getCategory(el) {
    return el && (el.getAttribute("data-dpz-track-evt-category") || el.getAttribute("data-dpz-track-event-category") || prepareLink.getCategoryFromContents(el) || el.getAttribute("type")) || "text";
  },
  getCategoryFromContents: function getCategoryFromContents(el) {
    if (el.nodeName === "BUTTON" || el.nodeName === "INPUT" && el.type === "submit") {
      return "button";
    }
    if (el.nodeName === "SELECT") {
      return "select";
    }
    if (el.querySelectorAll("img").length) {
      return "image";
    }
    return null;
  },
  getLabel: function getLabel(el) {
    return el.getAttribute("data-dpz-track-evt-label") || el.getAttribute("data-dpz-track-event-label") || prepareLink.getLabelFromAncestors(el) || null;
  },
  getLabelFromAncestors: function getLabelFromAncestors(el) {
    var parentGroup = getTargetAndAncestors(el).find(function (el) {
      return (document.documentElement.matches || document.documentElement.msMatchesSelector).call(el, "[data-dpz-track-group]");
    });
    return parentGroup && parentGroup.getAttribute("data-dpz-track-group");
  },
  getTealiumVariablesFromDataDpzTrack: function getTealiumVariablesFromDataDpzTrack(el) {
    var variables = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = el.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var attribute = _step.value;
        var name = attribute.name,
            value = attribute.value;

        if (name.startsWith("data-dpz-track-")) {
          variables[name.replace(/^data-dpz-track-(.*)/, "$1").replace(/-/g, "_")] = value;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return variables;
  }
};

exports.default = {
  init: init,
  view: view,
  link: link
};